import React from 'react';
import { graphql } from 'gatsby';

import SEO from '../components/seo';
import { Typography, Container, Box } from '@material-ui/core';
import { LegalPageBySlugQuery } from '../../types/graphql-types';
import CardImage from '../components/image/card-image';
import RichContent from '../components/text/rich-content';

export interface LegalPageProps {
  data: LegalPageBySlugQuery;
}

const LegalPage = ({ data }: LegalPageProps): JSX.Element => {
  const { contentfulLegal } = data;
  const image = contentfulLegal?.heroImage?.gatsbyImageData?.images?.fallback?.src;

  return (
    <>
      <SEO title={contentfulLegal?.title || ''} />
      <Box mb={5} mt={5}>
        <Container>
          <Typography component="h1" variant="h3" align="left" color="textPrimary" gutterBottom>
            {contentfulLegal?.title}
          </Typography>
          <Typography variant="h5" color="textSecondary" paragraph>
            {contentfulLegal?.description?.description}
          </Typography>
          <Typography variant="h6" align="left" color="textSecondary" component="p">
            {contentfulLegal?.publishDate}
          </Typography>
          <CardImage image={image} title="Image title" />
          <RichContent
            dangerouslySetInnerHTML={{
              __html: contentfulLegal?.body?.childMarkdownRemark?.html || '',
            }}
          />
        </Container>
      </Box>
    </>
  );
};

export default LegalPage;

export const pageQuery = graphql`
  query LegalPageBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulLegal(slug: { eq: $slug }) {
      title
      publishDate(formatString: "MMMM Do, YYYY")
      heroImage {
        gatsbyImageData(width: 1180, quality: 90)
      }
      description {
        description
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
